export default "__VITE_ASSET__BADDx1xu__"